import { render, staticRenderFns } from "./FileRecord.vue?vue&type=template&id=2ffd5f4e&"
import script from "./FileRecord.vue?vue&type=script&lang=js&"
export * from "./FileRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports